export default __webpack_public_path__ + "img/dash-800.c698e290.jpg";